import styled from 'styled-components'
import { Row } from 'ui/themes/globalStyles'

const EnlargedRow = styled(Row)`
  min-height: 70px;
  height: auto;
`

export const s = { EnlargedRow }
